/* Saif Trading — cart drawer, steppers, menu, search, gallery, rails.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      return window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cents)
        : 'Rs.' + (cents / 100).toLocaleString('en-US');
    } catch (e) { return 'Rs.' + (cents / 100); }
  };

  /* ------------------------------------------------------------ drawer */
  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshDrawer() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var live = drawer();
        if (fresh && live) {
          var wasOpen = live.classList.contains('is-open');
          live.innerHTML = fresh.innerHTML;
          if (wasOpen) live.classList.add('is-open');
        }
      })
      .catch(function () {});
  }

  function refreshCount() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.textContent = money(cart.total_price);
        });
        return cart;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------- add to cart */
  function addToCart(form, button) {
    var label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = '…'; }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return Promise.all([refreshCount(), refreshDrawer()]).then(openDrawer);
      })
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else window.location.href = window.Shopify.routes.root + 'cart';
      })
      .then(function () {
        if (button) { button.disabled = false; button.innerHTML = label; }
      });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return Promise.all([refreshCount(), refreshDrawer()]); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  /* --------------------------------------------------------- listeners */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open && document.body.dataset.cartType === 'drawer') {
      e.preventDefault(); openDrawer(); return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')) {
      e.preventDefault(); closeDrawer(); return;
    }

    var step = e.target.closest('[data-qty]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.stepper');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qty, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn.dataset.lineKey, parseInt(lineBtn.dataset.lineChange, 10));
      return;
    }

  });

  /* ------------------------------------- buy now: add, then go to checkout */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    var form = btn.form || btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (document.body.dataset.ajaxCart !== 'true') return;  /* let the form post */

    e.preventDefault();
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '\u2026';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        window.location.href = window.Shopify.routes.root + 'checkout';
      })
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        btn.disabled = false;
        btn.innerHTML = label;
      });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    if (document.body.dataset.ajaxCart !== 'true') return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-line-qty]');
    if (qtyInput) changeLine(qtyInput.dataset.lineKey, parseInt(qtyInput.value, 10) || 0);

    var variantSelect = e.target.closest('[data-variant-select]');
    if (variantSelect) {
      var root = variantSelect.closest('[data-product-root]');
      if (!root) return;
      var id = variantSelect.value;
      var idField = root.querySelector('input[name="id"]');
      if (idField) idField.value = id;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* FAQ: only one answer open at a time */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var group = d.getAttribute('data-accordion');
    if (!group) return;
    document.querySelectorAll('details[data-accordion="' + group + '"]').forEach(function (other) {
      if (other !== d) other.open = false;
    });
  }, true);

  /* gallery thumbnails — the main image slides in from the side it came from */
  function showGalleryMedia(gallery, thumb) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var main = gallery.querySelector('[data-gallery-main] img');
    var img = thumb.querySelector('img');
    if (!main || !img) return;

    var to = thumbs.indexOf(thumb);
    var from = 0;
    for (var n = 0; n < thumbs.length; n++) {
      if (thumbs[n].getAttribute('aria-current') === 'true') { from = n; break; }
    }
    if (to === from) return;
    var dir = to > from ? 1 : -1;

    thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });

    var src = img.dataset.full || img.src;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { main.src = src; main.srcset = ''; return; }

    /* out, in the direction of travel */
    main.style.transition = 'opacity .16s ease, transform .16s ease';
    main.style.opacity = '0';
    main.style.transform = 'translateX(' + (dir * -30) + 'px)';

    window.setTimeout(function () {
      main.src = src;
      main.srcset = '';
      /* jump to the far side with no transition, then glide back */
      main.style.transition = 'none';
      main.style.transform = 'translateX(' + (dir * 30) + 'px)';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          main.style.transition = 'opacity .3s ease, transform .36s cubic-bezier(.2,.7,.4,1)';
          main.style.opacity = '1';
          main.style.transform = 'translateX(0)';
        });
      });
    }, 165);
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    if (gallery) showGalleryMedia(gallery, thumb);
  });

  /* --------------------------------------------- gallery prev / next */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-gallery-prev],[data-gallery-next]');
    if (!nav) return;
    var gallery = nav.closest('[data-gallery]');
    if (!gallery) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (thumbs.length < 2) return;

    var i = 0;
    for (var n = 0; n < thumbs.length; n++) {
      if (thumbs[n].getAttribute('aria-current') === 'true') { i = n; break; }
    }
    i = (i + (nav.hasAttribute('data-gallery-next') ? 1 : -1) + thumbs.length) % thumbs.length;
    thumbs[i].click();
    if (thumbs[i].scrollIntoView) {
      thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var gallery = document.activeElement && document.activeElement.closest('[data-gallery]');
    if (!gallery) return;
    var sel = e.key === 'ArrowRight' ? '[data-gallery-next]' : '[data-gallery-prev]';
    var btn = gallery.querySelector(sel);
    if (btn) { e.preventDefault(); btn.click(); }
  });

  /* ------------------------------------------------- phone menu + search */
  function setMenu(open) {
    var m = document.querySelector('[data-menu]');
    if (!m) return;
    m.classList.toggle('is-open', open);
    m.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function toggleFind() {
    var f = document.querySelector('[data-find]');
    if (!f) return;
    var open = !f.classList.contains('is-open');
    f.classList.toggle('is-open', open);
    document.querySelectorAll('[data-find-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var i = f.querySelector('input[type="search"]'); if (i) i.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); setMenu(true); return; }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); setMenu(false); return; }
    if (e.target.closest('[data-find-toggle]')) { e.preventDefault(); toggleFind(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setMenu(false);
    var f = document.querySelector('[data-find].is-open');
    if (f) toggleFind();
  });

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- hero slider */
  function initSlides(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var track = root.querySelector('[data-slides-track]');
    if (!track) return;
    var n = track.children.length;
    if (n < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slides-dot]'));
    var every = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var i = 0, timer = null, x0 = null, swiped = false;

    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (!calm) timer = setInterval(function () { go(i + 1); }, every); }

    root.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; return; }
      if (e.target.closest('[data-slides-prev]')) { e.preventDefault(); go(i - 1); start(); return; }
      if (e.target.closest('[data-slides-next]')) { e.preventDefault(); go(i + 1); start(); return; }
      var d = e.target.closest('[data-slides-dot]');
      if (d) { e.preventDefault(); go(parseInt(d.getAttribute('data-slides-dot'), 10) || 0); start(); }
    }, true);

    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; swiped = false; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { swiped = true; go(i + (dx < 0 ? 1 : -1)); }
      start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  }
  function bootSlides() { document.querySelectorAll('[data-slides]').forEach(initSlides); }

  /* ------------------------------------------- announcement bar rotation */
  function startAnnouncements() {
    document.querySelectorAll('.notice--rotate[data-notice]').forEach(function (bar) {
      if (bar.dataset.rotating === 'true') return;
      var slides = bar.querySelectorAll('.notice__item');
      if (slides.length < 2) return;
      bar.dataset.rotating = 'true';

      var i = 0;
      var every = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      var timer = null;

      function step() {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (!calm) timer = setInterval(step, every); }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      start();
    });
  }
  startAnnouncements();
  bootSlides();

  /* header picks up a soft shadow once the page moves under it */
  (function () {
    var h = document.querySelector('[data-hdr]');
    if (!h) return;
    function mark() { h.classList.toggle('is-scrolled', window.scrollY > 4); }
    mark();
    window.addEventListener('scroll', mark, { passive: true });
  })();
  document.addEventListener('shopify:section:load', bootSlides);
  document.addEventListener('shopify:section:load', startAnnouncements);

  /* ------------------------------------------------------ carousel rails */
  /* the arrows live in the section head, which is a sibling of the rail,
     so scope the lookup to the whole section rather than to the rail itself. */
  function railScope(el) {
    return el.closest('.shopify-section') || el.closest('.shell') || document;
  }

  function railStep(rail) {
    var first = rail.querySelector('.card, .more');
    var w = first ? first.getBoundingClientRect().width : rail.clientWidth * 0.8;
    return Math.max(w + 14, 120);
  }

  function syncRail(rail) {
    var scope = railScope(rail);
    var prev = scope.querySelector('[data-rail-prev]');
    var next = scope.querySelector('[data-rail-next]');
    var max = rail.scrollWidth - rail.clientWidth;
    var scrollable = max > 4;
    if (prev) prev.disabled = !scrollable || rail.scrollLeft <= 2;
    if (next) next.disabled = !scrollable || rail.scrollLeft >= max - 2;
  }

  function syncAllRails() {
    document.querySelectorAll('[data-rail-track]').forEach(syncRail);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!btn) return;
    var rail = railScope(btn).querySelector('[data-rail-track]');
    if (!rail) return;
    var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
    rail.scrollBy({ left: dir * railStep(rail), behavior: calm ? 'auto' : 'smooth' });
  });

  function bindRails() {
    document.querySelectorAll('[data-rail-track]').forEach(function (rail) {
      if (rail.dataset.railBound === 'true') return;
      rail.dataset.railBound = 'true';
      rail.addEventListener('scroll', function () { syncRail(rail); }, { passive: true });
    });
    syncAllRails();
  }
  bindRails();
  window.addEventListener('load', syncAllRails);
  window.addEventListener('resize', syncAllRails);
  document.addEventListener('shopify:section:load', bindRails);

  /* --------------------------------------- sticky buy bar on product pages */
  (function () {
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor) return;
    bar.hidden = false;

    function place() {
      var past = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-up', past);
    }
    place();
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
  })();

  /* ---------------------------------------------- reveal sections on scroll */
  if (!calm && 'IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        seen.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    document.querySelectorAll('.band').forEach(function (el) {
      el.classList.add('reveal');
      seen.observe(el);
    });
  }
})();
